<mat-card appearance="outlined" id="login-onboard-card">
  <mat-toolbar> <span>Registration Form</span> </mat-toolbar>
  @if ((bannerStatus$ | async)) {
    <mat-toolbar
      id="login-banner"
      color="{{ bannerColor$ | async }}"
      fxFlexFill
      >
      <span id="login-banner-message"> {{ bannerMessage$ | async }} </span>
    </mat-toolbar>
  }
  <mat-stepper
    id="onboard-stepper"
    linear
    #stepper="matVerticalStepper"
    >
    <mat-step [stepControl]="profileForm" editable="false">
      <form
        novalidate
        id="profile-form"
        [formGroup]="profileForm"
        (ngSubmit)="step1Next(stepper)"
        >
        <ng-template matStepLabel id="profile-form-label">
          Create Account
        </ng-template>

        <div class="required">Required *</div>

        <mat-form-field>
          <input
            matInput
            id="profile-form-invite-hash"
            placeholder="Invite Code"
            formControlName="inviteHash"
            />
          @if (validate('inviteHash', 'required')) {
            <mat-error>
              Invite Code is required
            </mat-error>
          }
        </mat-form-field>

        <!-- First Name -->
        <mat-form-field>
          <input
            matInput
            trimInput
            type="text"
            id="profile-form-first-name"
            placeholder="First Name *"
            formControlName="firstName"
            />
          @if (validate('firstName', 'required')) {
            <mat-error>
              First name is required
            </mat-error>
          }
          @if (
            profileForm
            ?.get('firstName')
            ?.hasError('maxlength') &&
            profileForm?.get('firstName')?.touched
            ) {
            <mat-error
              >
              Maximum of 255 characters
            </mat-error>
          }
        </mat-form-field>

        <!-- Last Name -->
        <mat-form-field>
          <input
            matInput
            trimInput
            type="text"
            id="profile-form-last-name"
            placeholder="Last Name *"
            formControlName="lastName"
            />
          @if (validate('lastName', 'required')) {
            <mat-error>
              Last name is required
            </mat-error>
          }
          @if (
            profileForm?.get('lastName')?.hasError('minlength') &&
            profileForm?.get('lastName')?.touched
            ) {
            <mat-error
              >
              Minimum of 2 characters
            </mat-error>
          }
          @if (
            profileForm?.get('lastName')?.hasError('maxlength') &&
            profileForm?.get('lastName')?.touched
            ) {
            <mat-error
              >
              Maximum of 255 characters
            </mat-error>
          }
        </mat-form-field>

        <!-- Time Zone -->
        <mat-form-field>
          <mat-select
            placeholder="Timezone *"
            formControlName="timezone"
            >
            @for (tz of timezones; track tz) {
              <mat-option
                [value]="tz.abbreviation"
                >
                {{ tz.name }}
              </mat-option>
            }
          </mat-select>
          @if (
            profileForm?.get('timezone')?.hasError('maxlength') &&
            profileForm?.get('timezone')?.touched) {
            <mat-error>
              Timezone is required
            </mat-error>
          }
        </mat-form-field>


        <mat-form-field>
          <mat-select
            placeholder="State"
            formControlName="state"
            >
            @for (state of usStates; track state) {
              <mat-option
                [value]="state.abbreviation"
                >
                {{ state.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Email -->
        <mat-form-field>
          <input
            matInput
            id="profile-form-email"
            placeholder="Email"
            formControlName="email"
            required
            />
        </mat-form-field>
        <div
          formGroupName="passwordGroup"
          id="profile-form-password-group"
          flex-wrap="wrap"
          fxLayout="row wrap"
          fxLayoutAlign="start center"
          >
          <mat-form-field>
            <input
              matInput
              id="profile-form-password"
              type="password"
              placeholder="Password *"
              formControlName="newPassword"
              required
              />
            @if (
              validate(
              'passwordGroup.newPassword',
              'required'
              )
              ) {
              <mat-error
                >
                Password is required
              </mat-error>
            }
            @if (
              validate(
              'passwordGroup.newPassword',
              'pattern'
              ) &&
              !validate(
              'passwordGroup.newPassword',
              'required'
              )
              ) {
              <mat-error
                >
                Value must be a valid password
              </mat-error>
            }
          </mat-form-field>
          <mat-chip-listbox class="chip-margins">
            <mat-chip-option
              color="{{ chipColor('pwdLength') }}"
              selected="true"
              >8-256 Characters</mat-chip-option
              >
            </mat-chip-listbox>
            <mat-form-field>
              <input
                matInput
                id="profile-form-confirm-password"
                type="password"
                placeholder="Confirm Password *"
                formControlName="confirmPassword"
                required
                />
              @if (
                validate(
                'passwordGroup.confirmPassword',
                'required'
                )
                ) {
                <mat-error
                  >
                  Confirm password is required
                </mat-error>
              }
              @if (
                validate(
                'passwordGroup.confirmPassword',
                'required'
                ) &&
                !validate(
                'passwordGroup.confirmPassword',
                'required'
                )
                ) {
                <mat-error
                  >
                  Value must be a valid password
                </mat-error>
              }
              @if (
                validate(
                'passwordGroup.confirmPassword',
                'matchPassword'
                ) &&
                !validate(
                'passwordGroup.confirmPassword',
                'required'
                )
                ) {
                <mat-error
                  >
                  Value does not match
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div>
            <button
              mat-raised-button
              matStepperNext
              id="profile-form-next-btn"
              type="submit"
              [disabled]="profileForm?.untouched || !profileForm?.valid"
              color="primary"
              >
              Create Account
            </button>
          </div>
        </form>
        @if ((progressBar$ | async)) {
          <mat-progress-bar
            mode="indeterminate"
            id="profile-form-progress-bar"
            >
          </mat-progress-bar>
        }
      </mat-step>
      <mat-step editable="false" optional="true">
        <ng-template matStepLabel> Profile Pic </ng-template>
        @if (showThumbnail) {
          <div id="login-onboard-profile-container">
            <profile-thumbnail [profileData]="profileData$ | async">
            </profile-thumbnail>
          </div>
        }
        <mat-divider fxFlexFill [hidden]="true"></mat-divider>
        <button
          mat-raised-button
          fxFlexFill
          id="profile-Done-btn"
          color="primary"
          (click)="continue()"
          [disabled]="false"
          >
          Continue To Main Site
        </button>
        @if (loginFlag) {
          <mat-progress-bar
            mode="indeterminate"
            id="profile-form-login-bar"
            >
          </mat-progress-bar>
        }
      </mat-step>
    </mat-stepper>
    @if (!showThumbnail) {
      <mat-card-footer>
        <button
          id="login-onboard-cancel-btn"
          mat-button
          color="default"
          (click)="cancel()"
          >
          Cancel
        </button>
      </mat-card-footer>
    }
  </mat-card>
